import React, { useEffect, useState } from 'react';
import { Bar, Indicator, IndicatorContainer, Requirement, Requirements } from './styles';
import {
  PASSWORD_NUMBER_REGEX,
  PASSWORD_SYMBOLS_REGEX,
} from '../../constants/regex';
import { FormattedMessage } from 'react-intl';

function PasswordIndicator({password}) {
  const [strength, setStrength] = useState([]);
  const [criteria, setCriteria] = useState({});

  const strengthColors = {
    "1": "#cc0000",
    "2": "#ff0000",
    "3": "#ff9900",
    "4": "#0066ff",
    "5": "#00cc00"
  };

  const isLetter = (c) => {
    return PASSWORD_NUMBER_REGEX.test(c) === false && PASSWORD_SYMBOLS_REGEX.test(c) === false;
  };

  const checkStrength = (pw) => {
    const criteria = {
      length: pw.length >= 8,
      symbol: PASSWORD_SYMBOLS_REGEX.test(pw) ,
      upperCase: pw.split("").filter(c => c === c.toUpperCase() && isLetter(c)).length > 0,
      lowerCase: pw.split("").filter(c => c === c.toLowerCase() && isLetter(c)).length > 0,
      number: PASSWORD_NUMBER_REGEX.test(pw)
    };
    setCriteria(criteria);

    const keys = Object.keys(criteria);

    let pwStrength = [];
    keys.forEach(key => {
      if (criteria[key]) pwStrength.push(key);
    });
    setStrength(pwStrength);
  };

  useEffect(() => {
    checkStrength(password);
  }, [password]);

  if (password.length > 0) {
    return (
      <IndicatorContainer>
        <Indicator>
          {strength.map((_, i) =>
            <Bar color={strengthColors[strength.length.toString()]} index={i} />
          )}
        </Indicator>
        <Requirements>
          <Requirement valid={criteria["lowerCase"]}><FormattedMessage id="passwordCriteria.lowerCase" /></Requirement>
          <Requirement valid={criteria["length"]}><FormattedMessage id="passwordCriteria.length" /></Requirement>
          <Requirement valid={criteria["upperCase"]}><FormattedMessage id="passwordCriteria.upperCase" /></Requirement>
          <Requirement valid={criteria["number"]}><FormattedMessage id="passwordCriteria.number" /></Requirement>
          <Requirement valid={criteria["symbol"]}><FormattedMessage id="passwordCriteria.specialCharacter" /></Requirement>
        </Requirements>
      </IndicatorContainer>
    )
  } else return <React.Fragment />
}

export default PasswordIndicator;
